import { render } from "./Mv.vue?vue&type=template&id=613e4cfa&scoped=true&bindings={\"shared\":\"options\",\"format\":\"setup\",\"emit\":\"setup\",\"marked\":\"setup\",\"email\":\"props\"}"
import script from "./Mv.vue?vue&type=script&lang=js"
export * from "./Mv.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-613e4cfa"

export default script